<template>
  <div class="carstatistics">
    <m-title :titlelist="listitem"></m-title>
    <div class="carstatistics_content">
      <div class="canvas_top">
        <div class="title">车辆作业数量</div>
        <div class="chart_content">
          <div class="chart_content_title">
            <div class="bot_title_btn">
              <span>统计时间</span>
              <div class="select">
                <m-select
                  v-model="selectitem"
                  :list="dropdownitemlist"
                ></m-select>
              </div>
            </div>
            <div class="bar_right">
              <span class="line"></span>
              <span>车辆数量</span>
            </div>
          </div>
          <div class="t_chart" ref="t_chart"></div>
        </div>
      </div>
      <div class="canvas_bot">
        <div class="title">车辆作业时间</div>
        <div class="chart_content">
          <div class="chart_content_title">
            <div class="bar_right">
              <span class="chunk"></span>
              <span>该作业时长下的车辆数量</span>
            </div>
          </div>
          <div class="t_chart" ref="b_chart"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import mSelect from "@/components/mSelect";
import * as echarts from "echarts";
export default {
  data() {
    return {
      color: ["#17B6A1"],
      listitem: [{name:"统计分析"}, {name:"车辆作业统计"}],
      selectitem: "按月",
      dropdownitemlist: ["按周", "按月", "按年"],
      option1: {
        grid: {
          show: true,
          top: "5%",
          left: "0%",
          right: "0%",
          bottom: "5%",
          containLabel: true,
          borderWidth: 0,
          backgroundColor: "#F9F9F9",
        },
        tooltip: {
          trigger: "axis",
          textStyle: {
            fontSize: 13,
            fontFamily: "Source Han Sans CN",
          },
          padding: [2, 10],
          borderWidth: 0,
          axisPointer: {
            lineStyle: {
              type: "solid",
            },
          },
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 13,
            fontFamily: "Source Han Sans CN",
            color: "#666666",
            interval: 0,
          },
          data: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ],
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 13,
            fontFamily: "Source Han Sans CN",
            color: "#666666",
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            data: [
              820, 630, 901, 934, 1190, 1000, 1150, 1000, 900, 890, 1000, 900,
            ],
            type: "line",
            symbol: "circle",
            symbolSize: 9,
            showSymbol: false,
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#c1cde9", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#f6f6f8", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      },
      option2: {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          show: true,
          top: "5%",
          left: "0%",
          right: "0%",
          bottom: "5%",
          containLabel: true,
          borderWidth: 0,
          backgroundColor: "#F9F9F9",
        },
        xAxis: [
          {
            type: "category",
            data: [
              "1h",
              "2h",
              "3h",
              "4h",
              "5h",
              "6h",
              "7h",
              "8h",
              "9h",
              "10h",
              "11h",
              "12h",
              "13h",
              "14h",
              "15",
            ],
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: true,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              fontSize: 13,
              fontFamily: "Source Han Sans CN",
              color: "#666666",
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            type: "bar",
            barWidth: "60%",
            barWidth: 30,
            color: "#13D168",
            data: [
              620, 820, 1600, 1700, 1100, 1050, 900, 100, 900, 1100, 500, 650,
              350, 200, 100,
            ],
          },
        ],
      },
    };
  },
  components: {
    mTitle,
    mSelect,
  },
  mounted() {
    this.showpageview();
  },
  methods: {
    showpageview() {
      var t_chart = echarts.init(this.$refs.t_chart);
      var b_chart = echarts.init(this.$refs.b_chart);
      t_chart.setOption(this.option1);
      b_chart.setOption(this.option2);
    },
  },
};
</script>
<style lang="scss" scoped>
.carstatistics {
  position: relative;
    height: 100%;
  .carstatistics_content {
   position: absolute;
      top: 50px;
      bottom: 0;
      width: 100%;
      background: #fff;
    .canvas_top {
      position: relative;
      height: 49%;
      background: #fff;
    }
    .canvas_bot {
      position: absolute;
      width: 100%;
      top: 50%;
      bottom: 0;
      background: #fff;
    }
    .title {
      box-sizing: border-box;
      padding-left: 10px;
      height: 45px;
      line-height: 45px;
      font-size: 100%;
      font-weight: bold;
    }
    .chart_content {
      position: absolute;
      border-top: 1px solid #f3f4f5;
      top: 45px;
      bottom: 0;
      width: 100%;
    }
    .chart_content_title {
      box-sizing: border-box;
      height: 30px;
      line-height: 30px;
      width: 100%;
      font-size: 80%;
      .bot_title_btn {
        float: left;
        margin-left: 10px;
        .select {
          display: inline-block;
          vertical-align: middle;
          margin-left: 10px;
          width: 88px;
          height: 28px;
          background: #f3f4f5;
          border-radius: 4px;
        }
      }
      .bar_right {
        float: right;
        margin-right: 10px;
        .line {
          display: inline-block;
          vertical-align: middle;
          margin-right: 10px;
          width: 28px;
          height: 5px;
          background: #17B6A1;
          border-radius: 3px;
        }
        .chunk {
          display: inline-block;
          vertical-align: middle;
          margin-right: 10px;
          width: 10px;
          height: 10px;
          background: #13d168;
          border-radius: 3px;
        }
      }
    }
    .t_chart {
      position: absolute;
      top: 30px;
      bottom: 0;
      width: 100%;
    }
  }
}
</style>